<template>
    <div class="flex act-container">
        <div>
            <act-preview
                    navigationBg="#F72727"
                    phoneHeaderFixedColor="#fff"
                    navigationTitle="省钱卡">
                <img :src="ruleForm.gameBgp" style="width: 375px; height: 200px;" v-if="ruleForm.gameBgp">
                <div class="coupon-item"  v-for="(v, i) in ruleForm.saveMoneyCardRuleModelList" :key="i" v-if="ruleForm.saveMoneyCardRuleModelList.length > 0">
                    <div style="width: 365px; height: 120px; background: #ffffff; margin: 5px; float: left; border-radius: 5px;">
                        <p style="line-height: 60px; text-align: center; font-size: 16px;">{{v.saveMoneyCardName}}</p>
                        <div style="width: 315px; height: 40px; margin-top: 10px; background: url('https://imgcdn.hemiao100.com/mall/saveMoneyCardBg.PNG');
float: left; margin-left: 25px; background-size:315px 40px; background-position: center;">
                            <p style="width: 165px; height: 40px; line-height: 40px; text-align: center; color: #ffffff; float: left">
                                ￥<span style="font-size: 20px;">{{v.wxshopPrice}}</span>/{{v.validityDay}}天</p>
                            <p style="width: 150px; height: 40px; line-height: 40px; text-align: center; color: #ffffff; float: left">立即开通</p>
                        </div>
                    </div>
                </div>
                <div v-else style="text-align: center; margin-top: 20px;">
                    还没有省钱卡哦
                </div>
            </act-preview>
        </div>
        <div class="add-goods-containers">
            <div class="act-step-wrapper">
                <hm-step
                        :steps="steps"
                        :scroll="true"
                        :step="currentStep"
                        @scroll="windowScroll"
                ></hm-step>
            </div>
            <div class="act-wrapper">
                <el-scrollbar :style="{ height: scrollHeight + 'px' }">
                    <div class="pvw flex flex-wrap">
                        <div class="flex-4">
                            <el-form
                                    :model="ruleForm"
                                    :rules="rules"
                                    ref="ruleForm"
                                    label-width="170px"
                            >
                                <div id="base">1.基本信息</div>
                                <el-form-item label="活动标题" prop="gameName">
                                    <el-input
                                            maxlength="25"
                                            style="width: 400px"
                                            size="small"
                                            clearable
                                            class="mr10 ipt"
                                            v-model.trim="ruleForm.gameName"
                                            placeholder="请输入活动标题"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="活动时间段选择" prop="activityDate">
                                    <el-date-picker
                                            :default-time="['00:00:00', '23:59:59']"
                                            v-model="ruleForm.activityDate"
                                            :picker-options="pickerOptions"
                                            type="datetimerange"
                                            align="right"
                                            start-placeholder="活动开始时间"
                                            end-placeholder="活动结束时间"
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            size="small"
                                            class="mr10"
                                    ></el-date-picker>
                                </el-form-item>
                                <el-form-item label="活动分享文案" prop="gameShareContent">
                                    <el-input
                                            :maxlength="30"
                                            style="width: 400px"
                                            size="small"
                                            clearable
                                            class="mr10 ipt"
                                            v-model.trim="ruleForm.gameShareContent"
                                            placeholder="请输入活动分享文案，30字以内"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="背景音乐链接" prop="gameBgm">
                                    <el-input
                                            style="width: 400px"
                                            size="small"
                                            clearable
                                            class="mr10 ipt"
                                            v-model="ruleForm.gameBgm"
                                            placeholder="请输入音乐链接/音乐网络地址"
                                    ></el-input>
                                </el-form-item>

                                <el-form-item label="主图：" prop="mainImgUrl">
                                    <my-upload
                                            field="file"
                                            @crop-success="cropSuccess"
                                            @crop-upload-success="cropUploadSuccess"
                                            @crop-upload-fail="cropUploadFail"
                                            v-model="show"
                                            v-if="show"
                                            noCircle
                                            noSquare
                                            :width="750"
                                            :height="360"
                                            :headers="{ 'X-Access-Token': $token }"
                                            :params="{ fileDir: 'mallDecoration' }"
                                            :url="$uploadUrl"
                                            img-format="png"
                                    ></my-upload>
                                    <el-button
                                            type="primary"
                                            size="small"
                                            v-show="!ruleForm.gameBgp"
                                            @click="toggleShow"
                                    >上传</el-button
                                    >
                                    <span class="form-tip"
                                    >图片尺寸建议750x360（最多上传一张）</span
                                    >
                                    <div class="priview" v-if="ruleForm.gameBgp">
                                        <img :src="ruleForm.gameBgp" alt="主图" />
                                        <div class="opreat-wrapper flex item-center flex-center">
                                            <el-button type="text" @click="handleRemove"
                                            >删除</el-button
                                            >
                                        </div>
                                    </div>
                                </el-form-item>

                                <el-form-item label="活动规则说明" prop="gameRuleRemark">
                                    <hm-rich-editor
                                            v-model="ruleForm.gameRuleRemark"
                                            :html="ruleForm.gameRuleRemark"
                                    />
                                </el-form-item>

                                <div class="mt40" id="gameRule">
                                    {{ steps.length === 3 ? 2 : 2 }}活动规则
                                </div>

                                <el-form-item label="是否在个人中心标签" prop="showTag">
                                    <el-switch
                                            v-model="ruleForm.showState"
                                            active-text="开启"
                                            inactive-text="关闭"
                                            active-value="yes"
                                            inactive-value="no">
                                    </el-switch>
                                    <el-input v-if="ruleForm.showState == 'yes'"
                                              prop="showTag"
                                              placeholder="请输入显示标签(5字以内)"
                                              size="mini"
                                              v-model="ruleForm.showTag"
                                              style="margin-left: 20px;"
                                              :maxlength="5"
                                    ></el-input>
                                </el-form-item>

                                <el-form-item label="是否关联固定券" prop="fixedCouponState">
                                    <el-switch
                                            v-model="ruleForm.fixedCouponState"
                                            active-text="开启"
                                            inactive-text="关闭"
                                            active-value="yes"
                                            inactive-value="no">
                                    </el-switch>
                                    <div class="font-ms" v-if="ruleForm.fixedCouponState==='yes'">
                                    <span class="mr20">关联发券规则</span>
                                    <el-select size="small" v-model="ruleForm.fixedCouponSendId" clearable placeholder="请选择关联发放规则" @change="selectChange(ruleForm.fixedCouponSendId,'0')">
                                        <el-option
                                            v-for="(v,i) in CouponRules"
                                            :label="v.name"
                                            :value="v.couponSendId"
                                            :disabled="getDisable(v.couponSendId)"
                                            :key="i"
                                        ></el-option>
                                    </el-select>
                                    </div>
                                </el-form-item>

                                <el-form-item label="是否限制领券额度" prop="automateBeTeam">
                                    <el-switch
                                            v-model="ruleForm.quotaState"
                                            active-text="开启"
                                            inactive-text="关闭"
                                            active-value="yes"
                                            inactive-value="no">
                                    </el-switch>
                                    <span v-if="
                                          ruleForm.quotaState == 'yes'"
                                          style="margin-left: 20px;">
                                        <el-input  size="mini" type="number" style="width: 120px;"  v-model="ruleForm.quotaNum" placeholder="请输入领券额度">
                                        </el-input>元/30天
                                    </span>
                                    <div class="font-ms">领券额度关闭，则不限制领券额度，领券额度开启，则需要设置额度，30天内领券不能超过设定的额度。</div>
                                    <div class="font-ms">
                                    <span class="mr20">关联发券规则</span>
                                    <el-select size="small" v-model="ruleForm.couponSendId" clearable placeholder="请选择关联发放规则" @change="selectChange(ruleForm.couponSendId,'1')">
                                        <el-option
                                            v-for="(v,i) in CouponRules"
                                            :label="v.name"
                                            :value="v.couponSendId"
                                            :disabled="getDisable(v.couponSendId)"
                                            :key="i"
                                        ></el-option>
                                    </el-select>
                                    </div>
                                </el-form-item>

                                <el-form-item label="" prop="drawTypeList">
                                    <div class="flex batch flex-between item-center">
                                        <div>
                                            <el-button size="small" type="primary" @click="batchSetting"
                                            >添加规则
                                            </el-button
                                            >
                                        </div>
                                    </div>
                                    <el-table
                                            :data="ruleForm.saveMoneyCardRuleModelList"
                                            row-key="wxshopSkuId"
                                            border
                                            class="mt10"
                                            stripe
                                            max-height="400"
                                            style="width: 100%"
                                            :header-cell-style="{
                                            background: '#f7f7f7',
                                            color: '#606266'
                                            }"
                                    >
                                        <el-table-column
                                                type="index"
                                                label="序号"
                                                width="50"
                                        ></el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                align="center"
                                                label="省钱卡绑定商品"
                                                width="300px"
                                        >
                                            <template slot-scope="scope">
                                                <el-input
                                                        size="small"
                                                        class="mr10 ipt"
                                                        style="width: 270px"
                                                        :show-message="scope.row.wxshopSkuId"
                                                        v-model="scope.row.wxshopSpuName"
                                                        placeholder="请选择绑定权益商品（虚拟商品）"
                                                        @click.native="selectGood(scope.row,scope.$index)"
                                                        readonly
                                                ></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                align="center"
                                                prop="saveMoneyCardName"
                                                label="省钱卡名称"
                                                width="300px"
                                        >
                                            <template slot-scope="scope">
                                                <el-form-item prop="saveMoneyCardName">
                                                    <el-input
                                                            placeholder="请输入省钱卡名称（5字以内）"
                                                            size="small"
                                                            :maxlength="5"
                                                            v-model="scope.row.saveMoneyCardName"
                                                    ></el-input>
                                                </el-form-item>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                align="center"
                                                label="省钱卡有效期"
                                        >
                                            <template slot-scope="scope">
                                                <el-select v-model="scope.row.validityDay" size="small" style="width: 160px;" placeholder="请选择有效期">
                                                    <el-option label="30天" value="30"></el-option>
                                                    <el-option label="60天" value="60"></el-option>
                                                    <el-option label="90天" value="90"></el-option>
                                                    <el-option label="360天" value="360"></el-option>
                                                </el-select>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                align="center"
                                                label="售价"
                                        >
                                            <template slot-scope="scope">
                                                <span>￥{{scope.row.wxshopPrice}}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                align="center"
                                                label="操作"
                                                width="80px"
                                        >
                                            <template slot-scope="scope">
                                                <el-button
                                                        @click="deleteAppend"
                                                        circle
                                                        type="warning"
                                                        size="mini"
                                                        icon="hmicon icon-jianhao">
                                                </el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-form-item>
                                <div class="flex flex-center">
                                    <el-button
                                            type="primary"
                                            size="small"
                                            @click="submitForm"
                                    >发布
                                    </el-button
                                    >
                                    <el-button size="small" @click="$router.back(-1)"
                                    >返回
                                    </el-button
                                    >
                                </div>
                            </el-form>
                        </div>
                    </div>
                </el-scrollbar>
            </div>
        </div>
        <el-dialog :visible.sync="errValidGoods" width="30%" title="提示">
            <div>
                <div>
                    您有
                    <span class="error">{{ errInputResult.length }}</span
                    >条数据有误
                </div>
                <el-table :data="errInputResult" border class="small-table">
                    <el-table-column
                            prop="goodsSn"
                            header-align="center"
                            align="center"
                            label="无效货号"
                    ></el-table-column>
                    <el-table-column
                            header-align="center"
                            align="center"
                            prop="specBarcode"
                            label="无效条码"
                    ></el-table-column>
                </el-table>
            </div>
        </el-dialog>
        <el-dialog
                custom-class="import-dialog"
                title="添加商品"
                @show="queryVirtualList"
                width="70%"
                :visible.sync="selectGoodsWindow"
                :close-on-click-modal="false"
        >
            <div class="p20">
                <div class="table-panel flex flex-between">
                    <div class="flex text-right flex-end">
                        <el-input
                                clearable
                                style="width: 200px"
                                v-model.trim="searchDialogCondition.keyWords"
                                placeholder="请输入货号/条码/商品名称"
                                size="small"
                                class="ipt mr10"
                        ></el-input>

                        <el-input
                                clearable
                                v-model.trim="searchDialogCondition.minPrice"
                                placeholder="最低零售价"
                                size="small"
                                style="width: 100px"
                                class="ipt mr10"
                        ></el-input>
                        <el-input
                                clearable
                                v-model.trim="searchDialogCondition.maxPrice"
                                placeholder="最高零售价"
                                size="small"
                                style="width: 100px"
                                class="ipt mr10"
                        ></el-input>
                        <el-button type="primary" size="small" @click="searchGoods"
                        >查询</el-button
                        >
                        <el-button
                                type="info"
                                size="small"
                                @click="searchDialogCondition = {}"
                        >重置</el-button
                        >
                    </div>
                </div>
                <div class="table mb20">
                    <div class="tips mb20">提示：点击表格行即可选择</div>
                    <el-table
                            stripe
                            border
                            ref="brandTable"
                            @current-change="handleCurrentChange"
                            highlight-current-row
                            @selection-change="getChecked"
                            :data="virtualGoods.records"
                            style="width: 100%"
                            id="table"
                            size="small"
                    >
                        <el-table-column
                                type="index"
                                label="序号"
                                :index="
                index => index + (currentVirtualPage - 1) * pageVirtualSize + 1
              "
                        ></el-table-column>
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="wxshopSpuName"
                                label="商品名称"
                        ></el-table-column>
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="goodsSnAndBarcode"
                                show-overflow-tooltip
                                label="规格"
                        >
                            <template slot-scope="scope">
                                <div>
                                    <!-- <span>{{ scope.row.spuAttributeValueList.join() }}</span> -->
                                    <span>{{ scope.row.specIdGroupName }}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="categoryName"
                                label="类别"
                        ></el-table-column>
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="categoryName"
                                label="价格信息"
                        >
                            <template slot-scope="scope">
                                <div>
                                    <span>零售价：</span>
                                    <span class="rose">{{ scope.row.wxshopPrice }}</span>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="hm-pagination mb20">
                    <el-pagination
                            background
                            :total="virtualGoods.total"
                            @current-change="pagingVirtual"
                            @size-change="handleSizeVirtualChange"
                            layout="total, sizes, prev, pager, next, jumper"
                            :current-page="currentVirtualPage"
                    ></el-pagination>
                </div>
                <div class="btn-wrapper mb20 flex flex-center">
                    <el-button size="small" type="primary" @click="saveGoods"
                    >确 定</el-button
                    >
                    <el-button size="small" @click="selectGoodsWindow = false"
                    >取 消</el-button
                    >
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import HmStep from "@/components/HmStep";
    import myUpload from "vue-image-crop-upload";
    import HmRichEditor from "@/components/HmRichEditor";
    import {arrayUnique2} from "@/utils/utils";
    import actPreview from "@/components/actPreview";
    import {mapGetters} from "vuex";

    import XLSX from "xlsx";
    import HmFilterMSGoods from "@/components/HmFilterMSGoods";

    let wb; // 读取完成的数据
    let rABS = false; // 是否将文件读取为二进制字符串
    export default {
        components: {
            HmStep,
            myUpload,
            HmRichEditor,
            HmFilterMSGoods,
            actPreview
        },
        data() {
            const patterndLaunchTimeTypeFunc = function (rule, val, callback) {
                let flag = true;
                if (this.ruleForm.launchTimeType == "custom") {
                    if (!this.ruleForm.customTimeNum) {
                        flag = false;
                    }
                }
                if (flag) {
                    callback();
                } else {
                    return callback(new Error("请输入自定义时长时间"));
                }
            }.bind(this);
            const patterndDrawTypeListFunc = function (rule, val, callback) {
                let flag = true;
                    callback();

            }.bind(this);
            const patterndCouponListFunc = function (rule, val, callback) {
                let flag = true;
                    callback();
            }.bind(this);
            const actDate = function (rule, val, callback) {
                // if (val > +this.ruleForm.actMemberUpperLimit) {
                //   return callback(new Error("已报名人数不能大于活动人数上限"));
                // }
                if (!this.ruleForm.activityDate.length > 0) {
                    return callback(new Error("请选择活动时间段"));
                }

                callback();
            }.bind(this);
            const patterndMainImgUrlFunc = function (rule, val, callback) {
                if (!this.ruleForm.gameBgp) {
                    return callback(new Error("请选择主图"));
                }
                callback();
            }.bind(this);
            return {
                suoyin:'',
                linshi:[],
                currentVirtualPage:1,
                pageVirtualSize:10,
                searchDialogCondition: {},
                selectGoodsWindow:false,
                showGoodsSn: true,
                selectOther: false,
                selectAll: false,
                expressList: [],
                errValidGoods: false,
                errInputResult: [],
                pickerOptions: {
                    disabledDate(time) {
                        let curDate = new Date().getTime();
                        // 这里算出一个月的毫秒数,这里使用30的平均值,实际中应根据具体的每个月有多少天计算
                        let day = 365 * 24 * 3600 * 1000;
                        let dateRegion = curDate + day;
                        return (
                            time.getTime() < Date.now() - 8.64e7 || time.getTime() > dateRegion
                        );
                    }
                },
                endTime: "2019-11-11 18:12:00",
                isRadio: false,

                storeId: "",
                currentStep: 1,
                scrollHeight: 0,
                show: false,
                dialogVisible: false,
                steps: [
                    {
                        id: "base",
                        name: "基本信息"
                    },
                    {
                        id: "gameRule",
                        name: "活动规则"
                    }
                ],
                ruleForm: {
                    gameBgp: "",
                    gameType:'save_money_card',
                    couponSendId:'',
                    gameStartTime:'',
                    gameEndTime:'',
                    activityDate: [],
                    gameName: "",
                    gameRuleRemark: "",
                    gameShareContent: "",
                    gameBgm: "",
                    saveMoneyCardRuleModelList:[],
                    eachLaunchUpperLimit: "",
                    eachHelpUpperLimit: "",
                    automateBeTeam: "no",
                    launchTimeType: "gameEnd",
                    customTimeNum: "",
                    subStockType:'',
                    showState:'no',   //个人中心显示状态
                    showTag:'',       //显示标签
                    quotaState:'no',   //额度状态
                    quotaNum:'',       //额度
                    fixedCouponState: "no",
                    fixedCouponSendId: "",
                },
                screening: "",
                bargainType: "people",
                rule: [
                    {
                        name: "",
                        needHelpSum: "",
                        eachLaunchUpperLimit: "",
                        ruleNum: ""
                    }
                ],
                threshold: {
                    expressModeGroup: []
                },
                rules: {
                    visualJoinNum: [
                        {
                            pattern: /^[0-9]\d*$/,
                            message: "请输入正整数",
                            trigger: "blur"
                        },
                        {
                            required: true,
                            message: "请输入虚拟参与人数",
                            trigger: "blur"
                        }
                    ],
                    gameName: [
                        {
                            required: true,
                            message: "请输入活动标题",
                            trigger: "blur"
                        },
                        {min: 2, max: 20, message: "长度在 2 到 20 个字符", trigger: "blur"}
                    ],
                    gameShareContent: [
                        {
                            required: true,
                            message: "请输入活动分享文案",
                            trigger: "blur"
                        },
                        {min: 2, max: 30, message: "长度在 2 到 30 个字符", trigger: "blur"}
                    ],
                    mainImgUrl: [
                        {
                            required: true,
                            validator: patterndMainImgUrlFunc,
                            trigger: "blur"
                        }
                    ],
                    gameRuleRemark: [
                        {
                            required: true,
                            message: "请输入活动规则说明",
                            trigger: "blur"
                        }
                    ],
                    showTag:[
                        {
                            required: true,
                            message: "请输入显示标签",
                            trigger: "blur"
                        },
                        {min: 1, max: 5, message: "长度在5个字符以内", trigger: "blur"}
                    ],
                    activityDate: {
                        required: true,
                        validator: actDate,
                        trigger: "blur"
                    },
                    drawTypeList: [
                        {
                            required: true,
                            validator: patterndDrawTypeListFunc,
                            trigger: "blur"
                        },
                        {
                            required: true,
                            validator: patterndCouponListFunc,
                            trigger: "blur"
                        }
                    ],
                    subStockType: [
                        {
                            required: true,
                            message: "请选择扣减库存限制",
                            trigger: "blur"
                        }
                    ],
                    launchTimeType: [
                        {
                            required: true,
                            validator: patterndLaunchTimeTypeFunc,
                            trigger: "blur"
                        }
                    ],
                    saveMoneyCardName: [
                        {
                            required: true,
                            message: "请输入省钱卡名称",
                            trigger: "blur"
                        },
                        {min: 1, max: 5, message: "长度在5个字符以内", trigger: "blur"}
                    ]
                },

                options: [
                    {
                        value: "1",
                        label: "1"
                    }
                ],
                CouponRules:[],  //券规则
                actDesc: {},
                sole: Boolean,
                isCollapse: true,
                total: 0,
                couponList: [],
                currentPage: 1,
                pageSize: 10,
                selectedCoupons: [],
                currentRow: {},
                selectedOptions: [],
            };
        },
        computed: mapGetters(["storeStyle", "microShopStoreList","virtualGoods"]),
        watch: {},
        created() {
            /*this.$store.dispatch("queryMicroStoreList");
            this.queryExpressList();*/
        },
        mounted() {
            window.addEventListener("scroll", this.handleScroll, true);
            window.addEventListener("resize", this.handleResize, true);
            this.findCouponSendByEvent();
            this.calcHeight();
            if (this.$route.query.gameId) {
                this.activityDetail().then(res => {
                    for (let key in res.result) {
                        this.ruleForm[key] = res.result[key];
                    }

                    this.ruleForm.activityDate = [
                        res.result.gameStartTime,
                        res.result.gameEndTime
                    ];

                    this.ruleForm.gameBgp = res.result.gameBgp;

                    this.rule = res.result.couponRuleModelList;
                    this.rule.forEach(v => {
                        v.id = "";
                    });
                    this.ruleForm.gameId = "";
                });
            }
            this.$store.dispatch("queryStoreStyle");
        },
        destroyed: function () {
            window.removeEventListener("scroll", this.handleScroll); //  离开页面清除（移除）滚轮滚动事件
            window.removeEventListener("resize", this.handleResize);
        },
        methods: {
            selectGoods(){
                this.dialogVisible = true;
            },
            //关联发放规则
            async findCouponSendByEvent(){
                let params = {
                    pageNo: this.currentPage,
                    pageSize: this.pageSize
                }
                this.$store.dispatch("findCouponSendByEvent", params).then(res => {
                    if (res.code === "0") {
                        this.CouponRules = res.result;
                    }
                });
            },
            //优惠券选择
            getSelectedCoupons(val) {
                this.selectedCoupons = val;
            },
            // 运费模板
            async queryExpressList() {
                const {result} = await this.$store.dispatch("storeExpressConfigList");
                this.expressList = [];
                if (result.defaultTemplate) {
                    this.expressList.push(result.defaultTemplate);
                }
                this.expressList.push(...result.templateList);
            },
            getCheckedStore(storeList) {
                this.selectOther = storeList.findIndex(o => o !== "all") > -1;
                this.selectAll = storeList.findIndex(o => o === "all") > -1;
                if (this.selectAll) {
                    this.ruleForm.shopIds = ["all"];
                }
            },
            // 导出excel
            outputExcel() {
                require.ensure([], () => {
                    const {exportJsonToExcel} = require("@/utils/output/Export2Excel");
                    const tHeader = ["商品货号", "商品条码"];
                    const filterVal = [];
                    const data = this.formatJson(filterVal, []);
                    exportJsonToExcel(tHeader, data, "导入模板");
                });
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]));
            },
            // 导入excel
            importf(e) {
                const obj = e.target;
                const that = this;
                this.inputData = [];
                if (!obj.files) {
                    return;
                }
                let f = obj.files[0];
                let reader = new FileReader();
                reader.onload = function (e) {
                    let data = e.target.result;
                    if (rABS) {
                        wb = XLSX.read(btoa(this.fixdata(data)), {
                            // 手动转化
                            type: "base64"
                        });
                    } else {
                        wb = XLSX.read(data, {
                            type: "binary"
                        });
                    }
                    let result = null;
                    wb.SheetNames.forEach(sheetName => {
                        let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
                            header: 1
                        });
                        if (roa.length) {
                            result = roa.slice(1);
                        }
                    });

                    let goodsSnsAndSpecBarcode = [];
                    result.forEach(v => {
                        // if (v[0]) {
                        //   goodsSns.push(v[0]);
                        // }
                        if (v[0] || v[1]) {
                            goodsSnsAndSpecBarcode.push({
                                goodsSn: v[0] ? (v[0] + "").replace(/\s*/g, "") : "",
                                specBarcode: v[1] ? (v[1] + "").replace(/\s*/g, "") : ""
                            });
                        }
                    });

                    // goodsSns = unique(goodsSns);
                    that.$store
                        .dispatch("queryWxshopSkuByGoodsSn", {goodsSnsAndSpecBarcode})
                        .then(res => {
                            const {code, result} = res;
                            if (code === "0") {
                                if (result.modelList.length > 0) {
                                    result.modelList.forEach(v => {
                                        v.bargainTotalStockSum = "";
                                        v.eachPurchaseLimit = "1";
                                        v.integralValue = "";
                                    });
                                    that.rule.push(...result.modelList);
                                    that.rule = arrayUnique2(that.rule, "wxshopSkuId");
                                    let list = [];
                                    that.rule.forEach(v => {
                                        if (v.goodsSn !== "") {
                                            list.push(v);
                                        }
                                    });
                                    that.rule = list;
                                    that.$forceUpdate();
                                }
                                if (result.errGoodsSnsAndSpecBarcode.length > 0) {
                                    that.errValidGoods = true;
                                    that.errInputResult = result.errGoodsSnsAndSpecBarcode;
                                }
                            }
                        });
                };
                if (rABS) {
                    reader.readAsArrayBuffer(f);
                } else {
                    reader.readAsBinaryString(f);
                }
                obj.value = "";
            },
            isString(value) {
                return typeof value === "string";
            },
            fixdata(data) {
                // 文件流转BinaryString
                let o = "";
                let l = 0;
                let w = 10240;
                for (; l < data.byteLength / w; ++l)
                    o += String.fromCharCode.apply(
                        null,
                        new Uint8Array(data.slice(l * w, l * w + w))
                    );
                o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
                return o;
            },
            activityDetail() {
                const {gameId} = this.$route.query;
                const params = {
                    gameId
                };
                return this.$store.dispatch("queryActivitDetail", params);
            },
            cropSuccess() {
            },
            cropUploadFail() {
            },
            cropUploadSuccess(jsonData) {
                if (this.show) {
                    this.ruleForm.gameBgp = jsonData.result;
                } else if (this.showDetail) {
                    this.uploadedDetailList.push(jsonData.result);
                }
            },
            filterGt0OrFixed(prop, i) {
                this.rule[i][prop] = this.rule[i][prop].replace(/^(0+)/, ""); //过滤0开头
                this.rule[i][prop] = this.rule[i][prop].replace(/[^\d]/g, ""); //仅保留数字
                this.rule[i][prop] = this.rule[i][prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
                this.rule[i][prop] = this.rule[i][prop]
                    .replace(".", "$#*")
                    .replace(/\./g, "")
                    .replace("$#*", "."); //去除其他"."
                this.rule[i][prop] = this.rule[i][prop].replace(
                    /^(\d+)\.(\d\d).*$/,
                    "$1.$2"
                ); //限制只能输入两个小数
                if (this.rule[i][prop].indexOf(".") < 0 && this.rule[i][prop] != "") {
                    //首位是0的话去掉
                    this.rule[i][prop] = parseFloat(this.rule[i][prop]);
                }
            },
            filterGt0OrFixed2(prop, i) {
                console.log("prop", this.rule);
                console.log("i", i);
                // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
                this.rule[i][prop] = this.rule[i][prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
                this.rule[i][prop] = this.rule[i][prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
                this.rule[i][prop] = this.rule[i][prop]
                    .replace(".", "$#*")
                    .replace(/\./g, "")
                    .replace("$#*", "."); //去除其他"."
                this.rule[i][prop] = this.rule[i][prop].replace(
                    /^(\d+)\.(\d\d).*$/,
                    "$1.$2"
                ); //限制只能输入两个小数
                if (this.rule[i][prop].indexOf(".") < 0 && this.rule[i][prop] != "") {
                    //首位是0的话去掉
                    this.rule[i][prop] = parseFloat(this.rule[i][prop]);
                }
            },
            windowScroll(i) {
                this.$nextTick(() => {
                    document.getElementById(this.steps[i].id).scrollIntoView();
                    this.currentStep = i + 1;
                });
            },
            toggleShow() {
                this.show = !this.show;
            },
            handleResize() {
                this.calcHeight();
            },
            calcHeight() {
                setTimeout(() => {
                    const headerHeight = document.querySelector(".navbar")
                        ? document.querySelector(".navbar").getBoundingClientRect().y
                        : 0;
                    const tagHeight = document.querySelector(".tags-view-container")
                        ? document
                            .querySelector(".tags-view-container")
                            .getBoundingClientRect().y
                        : 0;
                    const stepsHeight = document.querySelector(".step-wrapper")
                        ? document.querySelector(".step-wrapper").getBoundingClientRect().y
                        : 0;
                    const footerHeight = document.querySelector(".el-footer")
                        ? document.querySelector(".el-footer").getBoundingClientRect().height
                        : 0;
                    this.scrollHeight =
                        window.innerHeight -
                        headerHeight -
                        tagHeight -
                        stepsHeight -
                        footerHeight -
                        80;
                }, 0);
            },
            handleScroll(e) {
                this.steps.map((v, i) => {
                    const ele = document.getElementById(v.id);
                    if (ele) {
                        const offsetTop = ele.offsetTop;
                        if (e.target.scrollTop + 360 > offsetTop) {
                            this.currentStep = i + 1;
                        } else {
                            this.currentStep = i - 1 <= 0 ? 1 : i - 1;
                        }
                    }
                });
            },
            addChild() {
                this.batchSetting();
            },
            deleteChild(index) {
                if (this.rule.length <= 1) {
                    this.rule = [];
                    this.addChild();
                    return;
                }
                this.rule.splice(index, 1);
            },
            async submitForm() {
                if(this.ruleForm.saveMoneyCardRuleModelList.length>0){
                    this.ruleForm.saveMoneyCardRuleModelList.forEach(v=>{
                        if(!v.wxshopSpuName || !v.wxshopSkuId || !v.saveMoneyCardName || !v.validityDay){
                            this.$message({
                                message: "请将规则信息填写完整",
                                type: "warning"
                            });
                            return false;
                        }
                    })
                }
                this.ruleForm.gameStartTime =
                    this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
                        ? this.ruleForm.activityDate[0]
                        : "";
                this.ruleForm.gameEndTime =
                    this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
                        ? this.ruleForm.activityDate[1]
                        : "";

                        await this.$store.dispatch("saveGameInfo", this.ruleForm).then(res => {
                            if (res.code === "0") {
                                this.$message({
                                    message: "操作成功",
                                    type: "success"
                                });
                                this.$router.back(-1);
                            }
                        });
            },
            handleRemove() {
                this.ruleForm.gameBgp = "";
            },
            sample() {
                this.dialogVisible = true;
            },
            saveCoupons() {
                console.log("selectedCoupons=====", this.selectedCoupons);
                if (this.selectedCoupons.length > 0) {
                    this.dialogVisible = false;
                    if (this.rule.length === 1) {
                        this.rule = [];
                    }
                    this.rule.push(...this.selectedCoupons);
                    this.rule = arrayUnique2(this.rule, "couponSendId");
                } else {
                    this.$message({
                        message: "请选择优惠券",
                        type: "warning"
                    });
                }
            },
            setLink() {
                this.dialogVisible = false;
                this.isRadio = false;
            },

            //查询优惠券
            queryCouponList() {
                let params = {
                    pageNo: this.currentPage,
                    pageSize: this.pageSize
                }
                this.$store.dispatch("findCouponSendByEvent", params).then(res => {
                    if (res.code === "0") {
                        this.couponList = res.result;
                    }
                });
            },
            batchSetting() {
                let params = {
                    wxshopSkuId:'',
                    saveMoneyCardName:'',
                    validityDay :'',
                    wxshopPrice:''
                };
                this.ruleForm.saveMoneyCardRuleModelList.push(params);
                console.log("this.ruleForm.saveMoneyCardRuleModelList=========>"+this.ruleForm.saveMoneyCardRuleModelList)
                // this.dialogVisible = true;
                // this.queryCouponList();
            },
            deleteAppend(){
                this.ruleForm.saveMoneyCardRuleModelList.pop();
            },
            minimum() {
                this.isCollapse = !this.isCollapse;
            },
            paging(page) {
                this.currentPage = page;
                this.queryList();
            },
            handleSizeChange(size) {
                this.currentPage = 1;
                this.pageSize = size;
                this.queryList();
            },
            searchGoods() {
                this.currentVirtualPage = 1;
                this.queryVirtualList();
            },
            queryVirtualList() {
                let params = {
                    pageSize: this.pageVirtualSize,
                    pageNo: this.currentVirtualPage,
                    spuType: "virtual",
                    isSaveMoneyCard:'yes',
                };
                const searchDialogCondition = JSON.parse(
                    JSON.stringify(this.searchDialogCondition)
                );
                Object.assign(params, searchDialogCondition);
                this.$store.dispatch("virtualGoods", params);
            },
            handleCurrentChange(row) {
                this.currentRow = row;
            },
            getChecked(selection) {
                this.checkedRow = selection.map(v => v.spuId);
            },
            pagingVirtual(page) {
                this.currentVirtualPage = page;
                this.queryVirtualList();
            },
            handleSizeVirtualChange(size) {
                this.currentVirtualPage = 1;
                this.pageSize = size;
                this.queryVirtualList();
            },
            saveGoods() {
                let flag = true;
                for(let i = 0; i<this.ruleForm.saveMoneyCardRuleModelList.length; i++ ){
                    if(this.ruleForm.saveMoneyCardRuleModelList[i].wxshopSkuId == this.currentRow.wxshopSkuId){
                        flag = false;
                    }
                };
                if(flag == false){
                    this.$message({
                        type: "warning",
                        message: "您已选择过该商品，请重新选择！"
                    });
                    return false;
                }
                if (!this.currentRow.spuId) {
                    this.$message({
                        type: "warning",
                        message: "请先选择商品"
                    });
                } else {
                    this.selectGoodsWindow = false;
                    this.ruleForm.saveMoneyCardRuleModelList[this.suoyin].wxshopSkuId = this.currentRow.wxshopSkuId;
                    this.ruleForm.saveMoneyCardRuleModelList[this.suoyin].wxshopSpuName = this.currentRow.wxshopSpuName;
                    this.ruleForm.saveMoneyCardRuleModelList[this.suoyin].wxshopPrice = this.currentRow.wxshopPrice;
                }
            },
            selectGood(val,index) {
                console.log(val,index);
                this.suoyin = index;
                this.linshi = val;
                this.selectGoodsWindow = true;
                this.queryVirtualList();
            },
            selectChange(value, index) {
                console.log(value, index);
                this.selectedOptions[index] = value;
            },
            getDisable(value) {
                if (this.selectedOptions.indexOf(value) >= 0) {
                    return true;
                } else {
                    return false;
                }
            },
        }
    };
</script>
<style lang="scss">
    .add-goods-containers {
        .el-scrollbar__wrap {
            overflow-x: hidden;
        }

        .step-wrapper {
            border-bottom: 1px solid #ddd;
        }

        .btn {
            margin-left: 10px;

            .hmicon {
                font-size: 12px;
                margin-right: 5px;
            }
        }
    }
</style>
<style lang="scss" scoped>
    .fixed-but {
        position: fixed;
        top: 150px;
        right: 20px;
    }

    .pvw {
        .pvws {
            border: 1px solid #d9d9d9;
            width: 350px;
            margin-right: 100px;
            position: relative;
            position: fixed;
            right: 0;

            .commodityImg {
                width: 150px;
                height: 100px;

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .actcontent {
                width: 161px;
                height: 100px;
                margin-left: 20px;

                .activityTitle {
                    font-size: 18px;
                    font-weight: 600;
                    margin-top: -1px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box; //作为弹性伸缩盒子模型显示。
                    -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
                    -webkit-line-clamp: 2; //显示的行
                }

                .activityPrice {
                    font-size: 24px;
                    color: #ff563a;
                    font-weight: 600;
                }

                .originalCost {
                    color: #919191;
                }
            }

            .hr {
                height: 10px;
                background-color: #f7f7f7;
            }

            .pvwimg {
                width: 100%;
                height: 100%;
                // position: relative;
            }

            .describe {
                width: 100%;
                color: #ffffff;
                font-size: 17px;
                position: absolute;
                left: 50%;
                margin-left: -50%;
                top: 248px;
            }
        }

        #audio_btn {
            position: absolute;
            left: 10px;
            top: 70px;
            z-index: 999999;
            width: 45px;
            height: 45px;
            background-image: url("https://imgcdn.hemiao100.com/hemiaoBase/ico_music.png");
            background-size: contain;
            background-repeat: no-repeat;
        }

        .rotate {
            -webkit-animation: rotating 1.2s linear infinite;
            -moz-animation: rotating 1.2s linear infinite;
            -o-animation: rotating 1.2s linear infinite;
            animation: rotating 1.2s linear infinite;
        }
    }

    .table {
        border: 1px solid #ddd;

        .table-header {
            padding: 16px 0;
            background: #f7f7f7;
            font-size: 14px;
            font-weight: bold;
        }

        .table-row {
            padding: 5px 0;
            font-size: 14px;
        }

        .table-row:nth-child(even) {
            background: #f7f7f7;
        }

        .add-wrapper,
        .minus-wrapper {
            margin: 0 auto;
        }
    }

    .priview {
        position: relative;
        width: 400px;
        height: 234px;
        border: 1px dashed #d9d9d9;
        border-radius: 6px;

        img {
            width: 100%;
            height: 100%;
        }

        .opreat-wrapper {
            transition: opacity 0.2s linear;
            position: absolute;
            opacity: 0;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.5);
            border-radius: 6px;
        }

        &:hover {
            .opreat-wrapper {
                opacity: 1;
            }
        }
    }

    .act-container {
        max-width: 2000px;
        overflow-x: auto;

        .step-wrapper {
            border-bottom: none !important;
            margin-bottom: 0;
        }

        .add-goods-container {
            width: 1128px;
            flex-shrink: 0;
        }

        .slot {
            .header-img-wrapper {
                box-sizing: border-box;

                .header-img {
                    width: 100%;
                    display: block;
                }
            }

            .empty {
                margin-top: 30px;
                text-align: center;
            }

            strong {
                font-size: 16px;
            }

            .preview-goods-list {
                padding: 15px;
                font-size: 12px;

                &:hover {
                    .add-goods {
                        display: block;
                        position: absolute;
                        cursor: pointer;
                        display: none;
                        top: 0;
                        left: 0;
                        z-index: 9030;
                        zoom: 1;
                        width: 34px;
                        height: 34px;
                        font-size: 12px;
                        background-color: rgba(0, 0, 0, 0.8);
                        border: 1px solid #fff;
                        border-radius: 4px;
                        text-align: center;
                        line-height: 34px;
                    }
                }

                .add-goods {
                    position: absolute;
                    top: 0;
                    left: 0;
                    display: none;
                }

                .coupon-item {
                    position: relative;
                    &:hover {
                        .delete-item {
                            display: block;
                        }
                    }

                    .goods-head {
                        border-radius: 20px;
                        background-color: #FFC1C1;
                        padding: 10px;
                        margin-bottom: 10px;
                        .head-ms {
                            padding: 10px 5px;
                            width: 75%;
                            .ms {
                                font-size: 16px;
                                color: #F72B2B;
                                margin-bottom: 20px;
                                font-weight: bold;
                            }
                            .rule-bq {
                                padding: 0px 4px;

                                height: 25px;
                                text-align: center;
                                line-height: 25px;
                                background: rgba(255, 255, 255, 0.46);
                                border-radius: 18px;
                                margin-right: 12px;
                                font-size: 12px;
                                color: #F72B2B;
                            }
                        }

                        .head-btn {
                            font-size: 16px;
                            padding: 3px 5px 10px 5px;
                            width: 25%;
                            color: #F72B2B;
                            font-weight: bold;
                            .btn-wrapper {
                                color: white;
                                padding: 0px 6px;
                                height: 38px;
                                font-size: 14px;
                                text-align: center;
                                line-height: 38px;
                                background: #F72B2B;
                                border-radius: 24px;
                            }
                        }
                    }

                    .goods-item {
                        background: #fff;
                        margin-bottom: 10px;
                        padding: 10px;
                        border-radius: 5px;

                        .rule-wrapper {
                            width: 30%;
                            padding: 0px 10px;
                            font-size: 18px;
                            color: #F72B2B;

                            .rule-money {
                                font-size: 48px;
                            }
                        }

                        .goods-name {
                            font-size: 14px;
                            font-weight: bold;
                            margin-bottom: 10px;
                        }

                        .tag {
                            font-size: 12px;
                            padding: 0 5px;
                            color: #fff;
                            border-radius: 30px;
                        }

                        .origin-price {
                            color: #999;
                            margin-top: 8px;
                            text-decoration: line-through;
                        }
                    }

                }
            }
        }

        .progress-wrapper {
            margin-bottom: 5px;

            .progress {
                position: relative;
                width: 134px;
                border-radius: 30px;
                overflow: hidden;
                height: 13px;
                line-height: 13px;

                .slide {
                    position: absolute;
                    top: 0;
                    left: 0;
                    bottom: 0;
                    height: 100%;
                    border-radius: 30px;
                }
            }

            .percent {
                font-size: 12px;
                margin-left: 10px;
            }
        }
    }

    .font-ms {
        font-size: 14px;
        color: #666666;
    }
</style>
